<template>
  <section style="padding:0 15px;">
    <table class="personnel-table" v-if="form">
      <tbody>
        <tr class="firstRow">
          <td width="85" valign="center">
            <p>
              <span>序&nbsp;号</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-input size="small" placeholder="列表中该员工的位置(请谨慎填写)" v-model="form.orderNum"></el-input>
          </td>
          <td width="85" valign="center">
            <p>
              <span style="color:#f00;">* 工&nbsp;号</span>
            </p>
          </td>
          <td width="" valign="center" colspan="3">
            <el-input size="small" placeholder="请输入" v-model="form.gh"></el-input>
          </td>
        </tr>
        <tr>
          <td width="85" valign="center">
            <p>
              <span style="color:#f00;">* 姓&nbsp;名</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-input size="small" placeholder="请输入" v-model="form.name"></el-input>
          </td>
          <td width="85" valign="center">
            <p>
              <span>性&nbsp;别</span>
            </p>
          </td>
          <td width="" valign="center" colspan="3">
            <el-input size="small" placeholder="请输入" v-model="form.sex"></el-input>
          </td>
        </tr>
        <tr>
          <td width="" valign="center">
            <p>
              <span style="color:#f00;">* 所属公司</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-select size="small" style="width:100%;" v-model="form.company">
              <el-option v-for="depName,i in depNames" :key="i" :label="depName" :value="depName"></el-option>
            </el-select>

            <!-- <el-input size="small" placeholder="请输入" v-model="form.company"></el-input> -->
          </td>
          <td width="" valign="center">
            <p>
              <span style="color:#f00;">* 所属部门</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-select filterable allow-create size="small" style="width:100%;" @change="forceUpdate" v-model="form.department">
              <el-option v-for="inDepName,j in depInDeps" v-if="inDepName.data" :key="j" :label="inDepName.data"
                :value="inDepName.data"></el-option>
            </el-select>
            <!-- <el-input size="small" placeholder="请输入" v-model="form.department"></el-input> -->
          </td>
          <td width="" valign="center">
            <p>
              <span>岗位及职务</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-input size="small" placeholder="请输入" v-model="form.zw"></el-input>
          </td>
        </tr>
        <tr>
          <td width="" valign="center">
            <p>
              <span>现任职时间</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-date-picker size="small" v-model="form.rxzsj" value-format="yyyy-MM-dd" type="date" placeholder="选择年月">
            </el-date-picker>
          </td>
          <td width="" valign="center">
            <p>
              <span>上一职级</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-input size="small" placeholder="请输入" v-model="form.syzj"></el-input>
          </td>
          <td width="" valign="center">
            <p>
              <span>任职时间</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-date-picker size="small" v-model="form.rzsj" value-format="yyyy-MM-dd" type="date" placeholder="选择年月">
            </el-date-picker>
          </td>
        </tr>
        <tr>
          <td width="80" valign="center">
            <p>
              <span>身份证号</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-input size="small" placeholder="请输入" v-model="form.idCard"></el-input>
          </td>
          <td width="" valign="center">
            <p>
              <span>进司时间</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-date-picker size="small" v-model="form.joinTime" value-format="yyyy-MM-dd" type="date"
              placeholder="选择年月">
            </el-date-picker>
          </td>
          <td width="" valign="center">
            <p>
              <span>司龄</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-input size="small" placeholder="请输入" v-model="form.gl"></el-input>
          </td>
        </tr>
        <tr>
          <td width="" valign="center">
            <p>
              <span>转正时间</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-date-picker size="small" v-model="form.zzTime" format="yyyy-MM" value-format="yyyy-MM" type="date"
              placeholder="选择年月">
            </el-date-picker>
          </td>
          <td width="" valign="center">
            <p>
              <span>政治面貌</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-input size="small" placeholder="请输入" v-model="form.zzmm"></el-input>
          </td>
          <td width="" valign="center">
            <p>
              <span>学历</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-input size="small" placeholder="请输入" v-model="form.hEdu"></el-input>
          </td>
        </tr>
        <tr>
          <td width="" valign="center">
            <p>
              <span>专业</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-input size="small" placeholder="请输入" v-model="form.hSchool"></el-input>
          </td>
          <td width="" valign="center">
            <p>
              <span>专业技术职称</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-input size="small" placeholder="请输入" v-model="form.position"></el-input>
          </td>
          <td width="" valign="center">
            <p>
              <span>人员类型</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-input size="small" placeholder="请输入" v-model="form.userType"></el-input>
          </td>
        </tr>
        <tr>
          <td width="" valign="center">
            <p>
              <span>生日</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-date-picker size="small" v-model="form.birthday" value-format="yyyy-MM-dd" type="date"
              placeholder="选择年月">
            </el-date-picker>
          </td>
          <td width="" valign="center">
            <p>
              <span>年龄</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-input size="small" placeholder="请输入" v-model="form.nl"></el-input>
          </td>
          <td width="" valign="center">
            <p>
              <span>退休日</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-date-picker size="small" v-model="form.txr" value-format="yyyy-MM-dd" type="date" placeholder="选择年月">
            </el-date-picker>
            <!-- <el-input size="small" placeholder="请输入" v-model="form."></el-input> -->
          </td>
        </tr>
        <tr>
          <td width="" valign="center">
            <p>
              <span>婚否</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-input size="small" placeholder="请输入" v-model="form.marriage"></el-input>
          </td>
          <td width="" valign="center">
            <p>
              <span>籍贯</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-input size="small" placeholder="籍贯(省市)" v-model="form.birthPlace"></el-input>
          </td>
          <td width="" valign="center">
            <p>
              <span>户籍所在地</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-input size="small" placeholder="户籍所在地(省市县)" v-model="form.birthAddress"></el-input>
          </td>
        </tr>
        <tr>
          <td width="" valign="center">
            <p>
              <span>现住址</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-input size="small" placeholder="请输入" v-model="form.homeAddress"></el-input>
          </td>
          <td width="" valign="center">
            <p>
              <span style="color:#f00;">* 手机</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-input size="small" placeholder="请输入" v-model="form.phone"></el-input>
          </td>
          <td width="" valign="center">
            <p>
              <span>短号</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-input size="small" placeholder="请输入" v-model="form.dh"></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="6" class="tool">劳动合同信息</td>
        </tr>
        <tr>
          <td width="" valign="center">
            <p>
              <span>起始日期</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-date-picker size="small" v-model="form.ldhtkssj" value-format="yyyy-MM-dd" type="date"
              placeholder="选择年月">
            </el-date-picker>
          </td>
          <td width="" valign="center">
            <p>
              <span>终止日期</span>
            </p>
          </td>
          <td width="" valign="center">
            <!-- <el-input size="small" placeholder="请输入" v-model="form.ldhtzzsj"></el-input> -->
            <el-date-picker size="small" v-model="form.ldhtzzsj" value-format="yyyy-MM-dd" type="date"
              placeholder="选择年月">
            </el-date-picker>
          </td>
          <td width="" valign="center">
            <p>
              <span>劳动合同期限</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-input size="small" placeholder="请输入" v-model="form.ldhtqx"></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="6" class="tool">社保信息</td>
        </tr>
        <tr>
          <td width="" valign="center">
            <p>
              <span>是否在缴</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-input size="small" placeholder="请输入" v-model="form.sb"></el-input>
          </td>
          <td width="" valign="center">
            <p>
              <span>开始缴纳时间</span>
            </p>
          </td>
          <td width="" valign="center" colspan="3">
            <el-date-picker size="small" v-model="form.sbkssj" value-format="yyyy-MM-dd" type="date" placeholder="选择年月">
            </el-date-picker>
          </td>
        </tr>
        <tr>
          <td colspan="6" class="tool">公积金信息</td>
        </tr>
        <tr>
          <td width="" valign="center">
            <p>
              <span>是否在缴</span>
            </p>
          </td>
          <td width="" valign="center">
            <el-input size="small" placeholder="请输入" v-model="form.gjj"></el-input>
          </td>
          <td width="" valign="center">
            <p>
              <span>开始缴纳时间</span>
            </p>
          </td>
          <td width="" valign="center" colspan="3">
            <el-date-picker size="small" v-model="form.gjjkssj" value-format="yyyy-MM-dd" type="date"
              placeholder="选择年月">
            </el-date-picker>
          </td>
        </tr>

      </tbody>
    </table>



  </section>
</template>

<script>
  export default {
    props: ['formByFather', 'userInfo'],
    data() {
      return {
        form: '',

        // 所有公司
        depNames: ['象山县水务集团有限公司', '象山县第一自来水有限公司', '象山县第二自来水有限公司', '象山县第三自来水有限公司', '象山县污水处理有限公司', '象山县原水有限公司',
          '象山县水务建设投资有限公司'
        ],
        depInDeps: [],
        // isUpload: false,
        // uploadUrl: axios.defaults.baseURL + '/common/upload',
        // mzArr: ["汉族", "满族", "蒙古族", "回族", "藏族", "维吾尔族", "苗族", "彝族", "壮族", "布依族", "侗族", "瑶族", "白族", "土家族", "哈尼族", "哈萨克族",
        //   "傣族", "黎族", "傈僳族", "佤族", "畲族", "高山族", "拉祜族", "水族", "东乡族", "纳西族", "景颇族", "柯尔克孜族", "土族", "达斡尔族", "仫佬族", "羌族",
        //   "布朗族", "撒拉族", "毛南族", "仡佬族", "锡伯族", "阿昌族", "普米族", "朝鲜族", "塔吉克族", "怒族", "乌孜别克族", "俄罗斯族", "鄂温克族", "德昂族", "保安族",
        //   "裕固族", "京族", "塔塔尔族", "独龙族", "鄂伦春族", "赫哲族", "门巴族", "珞巴族", "基诺族"
        // ],
        // zzmmArr: ['中共党员', '共青团员', '普通群众'],
        // hyzkArr: ['已婚', '未婚'],
        // xlArr: ['博士', '研究生', '本科', '大专', '高中', '中专', '初中', '小学'],
        // cwArr: ['父亲', '母亲', '儿子', '女儿', '岳父', '岳母'],
      }
    },
    mounted() {
      this.form = this.formByFather
    },
    methods: {
      // select刷新view
      forceUpdate(item) {
        this.$forceUpdate()
      },
      // // addLists
      // addLists(type) {
      //   switch (type) {
      //     case 1:
      //       this.form.resumes.push({
      //         "endTime": "",
      //         "jcRecord": "",
      //         "startTime": "",
      //         "workPlace": ""
      //       })
      //       break;
      //     case 2:
      //       this.form.positions.push({
      //         "endTime": "",
      //         "startTime": "",
      //         "workPlace": ""
      //       })
      //       break;
      //     case 3:
      //       this.form.families.push({
      //         "birthday": "",
      //         "callName": "",
      //         "job": "",
      //         "name": "",
      //         "phone": "",
      //         "zzmm": ""
      //       })
      //       break;
      //     default:
      //       break;
      //   }
      // },

      // 上传成功回调
      handleAvatarSuccess(res, file) {
        this.isUpload = false
        this.$set(this.form, 'img', res.vo.fileUrl)
      },
      getFromData() {
        return this.form
      }
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
      },

      // 部门
      'form.company'() {
        // this.form.inDep = ''
        ajax.post('/human/transfer/dept', {
          company: this.form.company
        }, res => {
          this.depInDeps = res.vo.array
        })
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/personnel/humanInfo.vue